var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"bordered":false,"size":"small"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('dialog-selected-tips',{attrs:{"name":_vm.$t('dictionary.identity_provider'),"count":_vm.data.length,"action":_vm.$t('system.text_246')}})]},proxy:true}])},[_c('dialog-table',{attrs:{"data":_vm.data,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }